import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../../../store/store';
import { loadDOMComponent } from '../../../helpers';
import { AppContextProvider } from '../../../Services/AppContext';
import SearchMedicamentRecord from './SearchMedicamentRecord';
import AclContextProvider from '../../../Modules/Acl/Components/AclContextProvider';
import { PatientDataContextProvider } from '../../../Modules/Patient/Services/PatientDataContext';

loadDOMComponent({
	selector: 'react-search-medicament-record',
	callback: ({ container, context }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<PatientDataContextProvider>
							<SearchMedicamentRecord setIsLoading={() => {}} />
						</PatientDataContextProvider>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
